export default "__VITE_ASSET__BjXGewZC__"